module.exports = __webpack_public_path__ + "img/c_2.79734f84.jpg";